import { propsValidator } from '../utils/helpers';
import Settings from '../views/AppContentPages/Settings';
import SettingsAccountEmailDomains from '../views/settings/AccountEmailDomains/SettingsAccountEmailDomains.vue';
import MissingSettings from '../views/settings/MissingSettings';
import SettingsCnames from '../views/settings/SettingsCnames';
/* Settings - Groups - subpages */
import Groups from '../views/settings/SettingsGroups';
import ManageApps from '../views/settings/SettingsManageApps';
import ManageCustomDomains from '../views/settings/SettingsManageCustomDomains';
import ManageUsers from '../views/settings/SettingsManageUsers';
import MySettings from '../views/settings/SettingsMySettings';
import SettingsOrganization from '../views/settings/SettingsOrganization';
import SettingsProfiles from '../views/settings/SettingsProfiles';
import ManageGroups from '../views/settings/groups/ManageGroups';
import ManageSingleGroup from '../views/settings/groups/ManageSingleGroup';

const getSettingRoutes = () => [
	{
		path: '',
		component: Settings,
		children: [
			{
				path: '',
				name: 'SettingsMe',
				component: MySettings,
				meta: {
					icon: 'my-settings',
					title: 'My Settings',
				},
			},
			{
				path: 'manage-apps',
				name: 'ManageApps',
				component: ManageApps,
				meta: {
					title: 'Manage Apps',
					icon: 'manage-apps-settings',
				},
			},
			{
				path: 'notifications',
				name: 'SettingsNotifications',
				component: MissingSettings,
			},
			{
				path: 'referrals',
				name: 'SettingsReferrals',
				component: MissingSettings,
			},
			{
				path: 'devices',
				name: 'SettingsDevices',
				component: MissingSettings,
			},
			{
				path: 'profiles',
				name: 'SettingsProfiles',
				component: SettingsProfiles,
				meta: {
					title: 'Profiles',
				},
			},
			{
				path: 'organization',
				name: 'SettingsOrganization',
				component: SettingsOrganization,
				meta: {
					icon: 'settings',
					title: 'Workspace Settings',
				},
			},
			{
				path: 'domain',
				name: 'AccountEmailDomains',
				component: SettingsAccountEmailDomains,
				meta: {
					title: 'Domains',
					icon: 'manage-domains',
				},
			},
			{
				path: 'cnames',
				name: 'SettingsCnames',
				component: SettingsCnames,
				meta: {
					title: 'Cnames',
				},
			},
			{
				path: 'organization/config',
				name: 'SettingsConfig',
				component: MissingSettings,
			},
			{
				path: 'organization/users',
				name: 'SettingsManageUsers',
				component: ManageUsers,
				meta: {
					icon: 'manage-users',
					title: 'Manage workspace members',
				},
			},
			{
				path: 'organization/groups',
				component: Groups,
				meta: {
					title: 'Groups',
				},
				children: [
					{
						path: '',
						name: 'ManageGroups',
						component: ManageGroups,
						meta: {
							title: 'Groups',
							icon: 'manage-groups',
						},
					},
					{
						path: ':groupId',
						props(route) {
							return propsValidator(route, ManageSingleGroup);
						},
						name: 'ManageSingleGroup',
						component: ManageSingleGroup,
						meta: {
							title: 'Group',
						},
					},
				],
			},
			{
				path: 'organization/custom-domains',
				name: 'SettingsCustomDomains',
				component: ManageCustomDomains,
				meta: {
					title: 'Manage workspace custom domains',
				},
			},
			{
				path: 'organization/billing',
				name: 'SettingsPlanBilling',
				component: MissingSettings,
			},
			{
				path: 'organization/security',
				name: 'SettingsSecurity',
				component: MissingSettings,
			},
			{
				path: 'organization/apps',
				name: 'SettingsAllowedApps',
				component: MissingSettings,
			},
		],
	},
];

export { getSettingRoutes };
